import md5 from 'js-md5'
import { initiateMultipartUpload, uploadPart, completeMultipartUpload } from '@/api/file'

export default async function uploadBigFile(file, callback) {
  if (!(file instanceof File)) {
    return Promise.reject(new Error('file error'))
  }

  const fileSize = file.size
  const SLICE_SIZE = 1024 * 1024 * 10 // 切片大小
  const SLICE_NUM = Math.ceil(fileSize / SLICE_SIZE) // 切片总数
  const TASK_NUM = 5 // 并发任务数量

  const sliceFile = file.slice(0, SLICE_SIZE)
  const fileBuffer = await fileReaderByBlob(sliceFile).catch()
  const md5File = md5(fileBuffer)

  const maxTask = SLICE_NUM < TASK_NUM ? SLICE_NUM : TASK_NUM

  const initFile = await initiateMultipartUpload({
    fileNameWithExtension: file.name,
    totalPartNumber: SLICE_NUM,
    md5: md5File
  }).catch(error => {
    return Promise.reject(error)
  })
  if (!('fileId' in initFile)) {
    return Promise.reject(new Error('分片初始化错误'))
  }
  const fileId = initFile.fileId
  const partNumber = initFile.partNumber
  await uploadQueue(
    maxTask,
    SLICE_NUM,
    SLICE_SIZE,
    file,
    fileId,
    md5File,
    processSize => {
      callback(Math.round((processSize / fileSize) * 100))
    },
    partNumber
  ).catch(error => {
    return Promise.reject(error)
  })

  const successFile = await completeMultipartUpload({ fileId }).catch(error => {
    return Promise.reject(error)
  })
  return Promise.resolve(successFile)
}

/**
 * 读取blob文件
 * @param {*} blobFile
 */
function fileReaderByBlob(blobFile) {
  const fr = new FileReader()
  fr.readAsArrayBuffer(blobFile)

  return new Promise((resolve, reject) => {
    fr.onload = () => {
      resolve(fr.result)
    }
    fr.onerror = error => {
      reject(error)
    }
  })
}

/**
 * 上传队列
 * @param {s} maxTask
 * @param {*} sliceNum
 * @param {*} sliceSize
 * @param {*} file
 * @param {*} fileId
 * @param {*} md5File
 */
function uploadQueue(maxTask, sliceNum, sliceSize, file, fileId, md5File, process, partNumber) {
  const processList = []
  for (let i = 0; i < sliceNum; i++) {
    processList.push(i)
  }
  const getFileSlice = index => {
    return file.slice(index * sliceSize, (index + 1) * sliceSize)
  }
  const getFormData = index => {
    const fileFormData = new FormData()
    fileFormData.append('fileId', fileId)
    fileFormData.append('file', getFileSlice(index))
    fileFormData.append('partNumber', index + 1)
    fileFormData.append('md5', md5File)
    return fileFormData
  }
  let remainder = sliceNum - maxTask
  let successCount = 0
  let errorCount = 0

  return new Promise((resolve, reject) => {
    function task(formData, index) {
      const p = partNumber.includes(index + 1)
        ? new Promise(resolve => {
            resolve()
          })
        : uploadPart(formData, loaded => {
            processList[index] = loaded
            let total = 0
            processList.forEach(item => {
              total += item
            })
            process(total)
          })
      return p
        .then(() => {
          successCount += 1
        })
        .catch(error => {
          errorCount += 1
          return Promise.reject(error)
        })
        .finally(() => {
          if (remainder > 0) {
            const i = sliceNum - remainder
            remainder -= 1
            return task(getFormData(i), i)
          } else {
            if (errorCount + successCount === sliceNum) {
              errorCount > 0 ? reject() : resolve()
            }
            return Promise.resolve()
          }
        })
    }

    for (let i = 0; i < maxTask; i++) {
      task(getFormData(i), i)
    }
  })
}
